module.exports = __webpack_public_path__ + "fonts/firacode-bold.0712393.ttf";